// apps/admin/src/lib/rects.ts
//
// Shared rectangle utilities extracted from planning/calendar-marquee.tsx
// (P5 UI Polish W6 T5). Used by both CalendarMarquee (W5 T1) and
// CanvasMarquee (W6 T5).

export interface Rect {
  x: number;
  y: number;
  w: number;
  h: number;
}

/**
 * Returns true iff rectangles a and b overlap (inclusive — edge-touch counts).
 * Both use the { x, y, w, h } form where x/y are the top-left corner.
 */
export function rectsIntersect(a: Rect, b: Rect): boolean {
  return !(a.x + a.w < b.x || b.x + b.w < a.x || a.y + a.h < b.y || b.y + b.h < a.y);
}
